import {
    type MultiChainEvents,
    YacsMultichainEventTypes,
    YacsMultichainTopicTypes,
} from '@app/client/common/structs/websockets/daas/events/multichain/events';

export const MC_EVENTS: MultiChainEvents = {
    floorpriceEvent: {
        listener: YacsMultichainEventTypes.floorpriceEvent,
        emitter: {
            name: YacsMultichainTopicTypes.floorprice,
        },
    },
    listingEvent: {
        listener: YacsMultichainEventTypes.listingEvent,
        emitter: {
            name: YacsMultichainTopicTypes.listing,
        },
    },
    saleEvent: {
        listener: YacsMultichainEventTypes.saleEvent,
        emitter: {
            name: YacsMultichainTopicTypes.sale,
        },
    },
    transferEvent: {
        listener: YacsMultichainEventTypes.transferEvent,
        emitter: {
            name: YacsMultichainTopicTypes.transfer,
        },
    },
};
